import PropTypes from 'prop-types';
import React, { Component } from 'react';

import {StandardPage} from "../../Common/pages/StandardPage";
import {RightColumn} from "../../Common/pages/RightColumn";

export default class ErrorPageContainer extends Component {
  static propTypes = {
    Error500Page: PropTypes.element,
    Error404Page: PropTypes.element,
    location: PropTypes.object.isRequired,
  };

  render() {
    const {
      location,
      Error500Page,
      Error404Page,
    } = this.props;

    return (
      <StandardPage sport="racing" title="Error">
        <div className="main-layout-left-column">
          {Error500Page}
          {Error404Page}
        </div>

        <RightColumn location={location}
                     sport="racing"
                     content={["ocWidget"]}/>
      </StandardPage>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/Errors/components/ErrorPageContainer.js